import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

// Shown when a customer mistakenly types a freight class into the NMFC field.
export function LineItemsNmfcFreightClassQuestionBubble() {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">
            FreightSimple automatically calculates Freight Class
          </T>
          <T size="xs" color="secondary">
            There is no need to enter the Freight class (eg. 50, 110, etc) when
            quoting for freight with FreightSimple.
          </T>
          <T size="xs" color="secondary">
            Certain commodities have 5-6 digit NMFC codes which can often help
            reduce shipping rates. If you would link help finding out the codes
            for your shipments please contact us and we can help
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/nmfc-codes-and-freight-class"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
}
